<template>
	<div id="app">
		<!--  导航栏  -->
		<navbar :to="'/'" />
		<!-- {{$store.getters.indexqueryvo.nowPlay}} -->
			
		<div class="containner flex justify-between item-start">
		
			<div class="left-panel">
		
				<div class="flex justify-between mt-40">
					<div class="text-xl weight gray">正在热映（{{$store.getters.indexqueryvo.nowPlayCount}}部）</div>
					<div class="text-sm gray hand">全部 &gt;</div>
				</div>
				<div class="flex item-start wrap mt-10">
					<div v-for="film of $store.getters.indexqueryvo.nowPlay" 
					:key="film.filmId" 
					@click="film_click (film.filmId)"
					class="film mx-10 my-10 px-10 py-10 rounded box-shadow hand hover-box-shadow-blue">
						<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>
						<div class="flex item-end justify-between mt-5">
							<div class="dark text-sm">{{film.filmName.length > 9 ? film.filmName.substr(0,9)+'...' : film.filmName}}</div>
							<div class="red text-xl weight">{{film.filmPraise}}</div>
						</div>
						<div class="buy">
							购票
						</div>
					</div>
					
				</div>
		
				<div class="flex justify-between mt-20">
					<div class="text-xl weight gray">即将上映（{{$store.getters.indexqueryvo.readyPlayCount}}部）</div>
					<div class="text-sm gray hand">全部 &gt;</div>
				</div>
				<div class="flex item-start wrap mt-10">
					<div v-for="film of $store.getters.indexqueryvo.readyPlay"
					:key="film.filmId" 
					@click="film_click (film.filmId)"
					class="film mx-10 my-10 px-10 py-10 rounded box-shadow hand hover-box-shadow-blue">
						<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>
						<div class="mt-5">
							<div class="dark text-sm">{{film.filmFavorite}}人想看</div>
						</div>
						<div class="buy">
							预售
						</div>
					</div>
				</div>
		
		
				<div class="flex justify-between mt-20">
					<div class="flex">
						<div class="text-xl weight gray mr-20">热播电影</div>
						<div class="flex">
							<div class="mr-40" v-for="cate of $store.getters.indexqueryvo.categories"
							:key="cate.cateId" >{{cate.cateName}}</div>
						</div>
					</div>
					
					<div class="text-sm gray hand">全部 &gt;</div>
				</div>
				<div class="flex item-start wrap mt-10">
					<div v-for="film of $store.getters.indexqueryvo.hotPlay"
					:key="film.filmId" 
					@click="film_click (film.filmId)"
					class="film mx-10 my-10 px-10 py-10 rounded box-shadow hand hover-box-shadow-blue">
						<img :src="'http://124.222.209.62/atstudy-cateye/imgs/film_avat/'+film.filmAvat" class="w-100"/>
						<div class="flex item-end justify-between mt-5">
							<div class="dark text-sm">{{film.filmName.length > 9 ? film.filmName.substr(0,9)+'...' : film.filmName}}</div>
							<div class="red text-xl weight">{{film.filmPraise}}</div>
						</div>
		
					</div>
				</div>
		
			</div>
		
			<div class="right-panel">
				<film_list
					:film_list="$store.getters.indexqueryvo.costPlay"
					:title="'今日票房'"
					:type="'1'"></film_list>
				<film_list
					:film_list="$store.getters.indexqueryvo.favPlay"
					:title="'最受期待'"
					:type="'2'"></film_list>
				<film_list
					:film_list="$store.getters.indexqueryvo.topPlay"
					:title="'Top 100'"
					:type="'3'"></film_list>
			</div>
		
		</div>
		<foot />
	</div>
</template>

<script>
	
	import {imgUrl} from '@/components/common.js'
	
	import navbar from '@/components/navbar.vue'
	import foot from '@/components/foot.vue'
	import film_list from '@/components/film_list.vue'

	export default {
		data () {
			return {
				imgUrl : imgUrl
			}
		},
		components:{
			navbar,
			foot,
			film_list
		},
		methods:{
			film_click (filmId) {
				this.$router.push({
					path: `/film/${filmId}`
				})
			}
		},
		mounted () {
			// console.log('begin....')
			this.$store.dispatch('actIndexLoads')
		}
	}
</script>

<style>
	.left-panel{width: 800px;}
	.right-panel{width: 380px; margin-left: 20px;}
	.buy {width: 100%; height: 40px; line-height: 40px; text-align: center;color: #aa401d; margin-top: 15px;border: 1px solid #d2d5ff;}
</style>
